function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 3C5 1.34315 3.65685 0 2 0H0V2H2C2.55228 2 3 2.44772 3 3V15C3 15.5523 2.55228 16 2 16H0V18H2C3.65685 18 5 16.6569 5 15V3Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3C3 1.34315 4.34315 0 6 0H8V2H6C5.44772 2 5 2.44772 5 3V15C5 15.5523 5.44772 16 6 16H8V18H6C4.34315 18 3 16.6569 3 15V3Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 10H1V8H7V10Z",
  fill: "currentColor"
});
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/RenameIcon.3588f52fcf1a096294a7fdc27b383745.svg";
export { ForwardRef as ReactComponent };